import React, { FC, useEffect, useState } from 'react';

import { getPermissionsListFetch } from 'src/resources/permissionsList/reducer';
import { RootStoreType } from 'src/types/store';
import { useDispatch, useSelector } from 'react-redux';
import translate from '@translate';
import { setLocationParams } from 'src/resources/location/reducer';
import { useCheckPermission } from 'src/utils/checkPermission';
import TopBlock from './TopBlock';
import Tree, { TreeNodeType } from 'src/components/Tree';
import { useNavigate } from 'react-router-dom';
import LaunchIcon from '@mui/icons-material/Launch';
import { IconButton, IconButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PERMISSION_ID_KEY = 'PID';

export interface PermissionsListContainerPropsType {}

const LaunchButton = styled(IconButton)<IconButtonProps>(({ theme }) => ({
    position: 'absolute',
    top: 0,
    right: 0,
    padding: '1px',
}));

const PermissionsListContainer: FC<PermissionsListContainerPropsType> = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const loading = useSelector((state: RootStoreType) => state.permissionsList.loading);
    const permissionsList = useSelector((state: RootStoreType) => state.permissionsList.data);

    const permissionCreate = useCheckPermission('PERMISSION.CREATE');
    const permissionDeatil = useCheckPermission('PERMISSION.DETAIL');

    useEffect(() => {
        dispatch(setLocationParams({ name: translate('permissions.title') }));
    }, []);

    useEffect(() => {
        if (!permissionsList) {
            dispatch(getPermissionsListFetch());
        }
    }, [permissionsList]);

    const reloadList = () => {
        dispatch(getPermissionsListFetch());
    };

    const handleClickItem = (item: TreeNodeType) => {
        navigate(`/admin/permissions/${item.ID}/`);
    };

    return (
        <>
            <TopBlock reloadList={reloadList} permissionCreate={permissionCreate} />
            {permissionsList && (
                <Tree
                    loading={loading}
                    data={permissionsList}
                    treeKey={PERMISSION_ID_KEY}
                    defaultTitle={translate('permissions.title')}
                    onClickItem={handleClickItem}
                    customLabelElement={
                        !permissionDeatil
                            ? undefined
                            : (item) => {
                                  return (
                                      <LaunchButton>
                                          <LaunchIcon />
                                      </LaunchButton>
                                  );
                              }
                    }
                />
            )}
        </>
    );
};

export default PermissionsListContainer;
